(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    //
    //

  function pxPrintQueueWorkstations(
    WorkstationListService, WorkstationListPOSTPaging, URLS, URL_PARAMS,
    EventServiceEvents, SUPPORTED_OS, $location, toastr, $filter, $ngBootbox
  ) {
    return {
      restrict: 'EA',
      scope: {

        tenant: '=tenant',
        me: '=me',
        isThisResourceMine: '=isThisResourceMine',
        printer: '=printer',
        printQueue: '=printQueue',
        printQueueOriginal: '=printQueueOriginal',

        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/workstations/printQueueWorkstations.template.html',
      link: function(scope) {

        scope.workstationListPaging = new WorkstationListPOSTPaging();
        scope.workstationListPaging.pagingCriteria.queue = scope.printQueue.info._links.self.href;
        scope.workstationListPaging.pagingCriteria.queueFilterMode = 'PRESENT';
        scope.remoteQueueManagementCalibrationObject = {
          searchInputPlaceholderText: "SearchQueueByName"
        };
        scope.remoteQueueManagementCalibrationObject.originalModel = scope.printQueueOriginal;
        scope.remoteQueueManagementCalibrationObject.pagingObject = new WorkstationListPOSTPaging();
        scope.remoteQueueManagementCalibrationObject.requestType = "POST";
        scope.remoteQueueManagementCalibrationObject.context = "addOneQueuToManyWorkstations";
        scope.remoteQueueManagementCalibrationObject.setHelpCaptionRemoteQueueManagement = "HelpPrintQueueuPropertiesRemoteQueueManagament";
        scope.remoteQueueManagementCalibrationObject.resetHelpCaptionRemoteQueueManagement = "HelpPrintQueuePropertiesComputers";
        scope.remoteQueueManagementCalibrationObject.tooltip = 'AddQueueToWorkstationsTooltip';
        scope.remoteQueueManagementCalibrationObject.supportedOs = reduceAmountOfOS();
        scope.supportedOsRaw = SUPPORTED_OS;

        (function() {

          getWorkstationListPaged();
          setListeners()
        })();

        scope.supportedOsRaw = SUPPORTED_OS;

        function reduceAmountOfOS() {
          var reducedSupportedOs = [];
          var avaliableOS = scope.tenant.info._embedded.wsCountPerOs.wsCountPerOs;
          for (var key in avaliableOS) {
            for (var i = 0; i < SUPPORTED_OS.length; i++) {
              if (SUPPORTED_OS[i].key === key) {
                reducedSupportedOs.push(SUPPORTED_OS[i]);
              }
            }
          }
          reducedSupportedOs = removeAndReplaceMacOS(reducedSupportedOs);
          return reducedSupportedOs;
        }

        function removeAndReplaceMacOS(operatingSystems) {
          var cleanOsList = [];
          var foundMAC_OS = false;
          angular.forEach(operatingSystems, function (os) {
            if (os.key.substring(0, 3) !== 'MAC') {
              cleanOsList.push(os);
            } else {
              foundMAC_OS = true;
            }
          })
          if (foundMAC_OS) {
            cleanOsList.push({ key: 'MAC_OS', value: 'macOS', index: 19 });
          }
          return cleanOsList;
        }

        function getWorkstationListPaged () {
          WorkstationListService.postGetWorkstationListPaged(scope.workstationListPaging).then(function (workstationContainer) {
            scope.workstationContainer = workstationContainer;
          }).catch(function(error){});
        }

        scope.getWorkstationListPaged = function () {
          getWorkstationListPaged();
        };

        scope.getNextPage = function functionName(showPrevious) {
          if (showPrevious) {
            if (scope.workstationListPaging.pagingCriteria.page > 0) {
              scope.workstationListPaging.pagingCriteria.page--;
            }
          } else {
            if (scope.workstationListPaging.pagingCriteria.page + 1 < scope.workstationContainer.page.totalPages) {
              scope.workstationListPaging.pagingCriteria.page++;
            }
          }
          scope.getWorkstationListPaged();
        }

        scope.changeOrderByValue = function (textValue) {
          scope.reverseWorkstations = !scope.reverseWorkstations;
          if (scope.reverseWorkstations) {
            scope.workstationListPaging.pagingCriteria.direction = 'DESC';
          } else {
            scope.workstationListPaging.pagingCriteria.direction = 'ASC';
          }
          scope.workstationListPaging.pagingCriteria.sort = textValue;
          scope.orderWorkstationsByText = SORT_WORKSTATIONS[textValue];
          scope.getWorkstationListPaged();
        };

        scope.editSelectedWorkstations = function (workstation, showSection) {
          if (workstation) {
            var url = URLS.WORKSTATION_PROPERTIES.replace(URL_PARAMS.WORKSTATION_ID.LOCATION, workstation.customProperties.id);
            $location.path(url).search(URL_PARAMS.SHOW_WORKSTATION_SECTION.ROUTE, showSection);
          } else {
            throw "scope.editSelectedWorkstations: workstation is missing";
          }
        }

        scope.selectAllItems = function() {
          angular.forEach(scope.workstationContainer.list, function(value) {
            value.options.isSelected = scope.selectAllWorkstations.selected;
          });
        };

        scope.forceWorkstationsToGetLatestQueueUpdates = function() {
          var message = $filter('stringular')($filter('translate')('PrintQueueUpdateOnComputers'));
          $ngBootbox.confirm(message).then(function() {
            var workstationModel = scope.workstationContainer.list[0];
            workstationModel.forceWorkstationsToGetLatestQueueUpdates(scope.printQueue, scope.printer).then(function() {
              toastr.success($filter('stringular')($filter('translate')('PrintQueueUpdatedOnComputers'), scope.printQueue.info.name));
            }).catch(function(error) {
              toastr.error($filter('translate')('UpsSomethingWentWrong'));
            });
          }).catch(function(error) {});
        }

        scope.deleteWorkstations = function (workstation) {
          var workstations = [];
          var printerId = scope.printer.info._links.self.href;

          if (workstation) {
            workstations.push(workstation.info);
          } else {
            var workstationsSelected = scope.workstationContainer.list.findAllElements({
              options: {
                isSelected: true
              }
            });
          }

          angular.forEach(workstationsSelected, function(workstation) {
            workstations.push(workstation.info);
          })

          if (workstations.length > 0) {
            var message = "";
            if (workstations.length < 2) {
              message = $filter("stringular")($filter("translate")("DeletePrintQueueOnComputer"), scope.printQueueOriginal.info.name, workstations[0].name);
            } else {
              message = $filter("stringular")($filter("translate")("DeletePrintQueueOnComputers"), scope.printQueueOriginal.info.name, workstations.length);
            }

            $ngBootbox.confirm(message).then(function() {
              scope.printQueueOriginal.deleteSelectedWorkstations(workstations, printerId).then(function() {
                var message = "";
                if (workstations.length < 2) {
                  message = $filter("stringular")($filter("translate")("PrintQueueDeletedOnComputer"), scope.printQueueOriginal.info.name, workstations[0].name);
                } else {
                  message = $filter("stringular")($filter("translate")("PrintQueueDeletedOnComputers"), scope.printQueueOriginal.info.name, workstations.length);
                }
                toastr.success(message);
              }).catch(function(error) {});
            }).catch(function(error) {});
          } else {
            toastr.error($filter("translate")("SelectPrintQueueNone") + ", " + $filter("translate")("SelectPrintQueue"));
          }

        }

        scope.setHelpCaptionRemoteQueueManagement = function () {
          scope.helpCaption = scope.remoteQueueManagementCalibrationObject.setHelpCaptionRemoteQueueManagement;
        }

        scope.resetHelpCaptionRemoteQueueManagement = function () {
          scope.helpCaption = scope.remoteQueueManagementCalibrationObject.resetHelpCaptionRemoteQueueManagement;
        }

        function setListeners () {

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_QUEUE_ADDED, function(name, data){
            if (data.queue === scope.printQueue.info._links.self.href) {
              getWorkstationListPaged();
            }
          });

          scope.$on(EventServiceEvents.CHANNELS.ALL_TENANT_ADMINS.EVENTS.WORKSTATION_QUEUE_REMOVED, function(name, data){
            if (data.queue === scope.printQueue.info._links.self.href) {
              getWorkstationListPaged();
            }
          });
        }
      }
    };
  }

  pxPrintQueueWorkstations.$inject = [
    'WorkstationListService', 'WorkstationListPOSTPaging', 'URLS', 'URL_PARAMS',
    'EventServiceEvents', 'SUPPORTED_OS', '$location', 'toastr', '$filter', '$ngBootbox'
  ];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueWorkstations', pxPrintQueueWorkstations);

})();
